'use client';
import { useEffect, useState } from 'react';
import { useCompte } from '@/lib/auth/client';

/**
 * useIsAdmin — vérifie le rôle admin depuis la DB (via /api/me/is-admin).
 * Ne se déclenche qu'une fois la session connue et l'utilisateur connecté.
 */
export function useIsAdmin(): { isAdmin: boolean; isLoaded: boolean } {
  const { isLoaded: authLoaded, isSignedIn } = useCompte();
  const [isAdmin, setIsAdmin]   = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!authLoaded) return;
    if (!isSignedIn) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setIsAdmin(false);
       
      setIsLoaded(true);
      return;
    }
    fetch('/api/me/is-admin')
      .then(r => r.json())
      .then((data: { isAdmin: boolean }) => setIsAdmin(data.isAdmin))
      .catch(() => setIsAdmin(false))
      .finally(() => setIsLoaded(true));
  }, [authLoaded, isSignedIn]);

  return { isAdmin, isLoaded };
}
